import { render, staticRenderFns } from "./SorguKaynakRozeti.vue?vue&type=template&id=6574ca40"
import script from "./SorguKaynakRozeti.vue?vue&type=script&lang=ts"
export * from "./SorguKaynakRozeti.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports